import Chemicals from './Chemicals.webp';
import Door from './Door.webp';
import Cafeteria from './Cafeteria.webp';
import Stairs from './Stairs.webp';
import Servers from './Servers.webp';
import Hallway from './Hallway.webp';

export default {
    Chemicals,
    Door,
    Cafeteria,
    Stairs,
    Servers,
    Hallway
}